import { useState, useEffect } from 'react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <button
      type="button"
      onClick={scrollTop}
      className={`back-to-top ${visible ? 'back-to-top--visible' : ''}`}
      aria-label="Voltar ao topo"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="24" height="24">
        <path d="M12 19V5M5 12l7-7 7 7" strokeLinecap="round" strokeLinejoin="round" />
      </svg>

      <style>{`
        .back-to-top {
          position: fixed;
          bottom: 104px;
          right: 32px;
          z-index: 999;
          width: 52px;
          height: 52px;
          border: none;
          border-radius: 50%;
          background: var(--orange, #F26C2E);
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 8px 24px rgba(242,108,46,.4);
          opacity: 0;
          visibility: hidden;
          transform: scale(0.6) translateY(20px);
          transition: opacity .35s ease, transform .35s cubic-bezier(.2,.8,.2,1), box-shadow .3s, background .25s, visibility .35s;
        }
        .back-to-top--visible {
          opacity: 1;
          visibility: visible;
          transform: scale(1) translateY(0);
        }
        .back-to-top:hover {
          background: #d95c22;
          box-shadow: 0 12px 32px rgba(242,108,46,.55);
          transform: scale(1.1) translateY(-3px);
        }
        @media (max-width: 600px) {
          .back-to-top { bottom: 84px; right: 20px; width: 46px; height: 46px; }
        }
      `}</style>
    </button>
  );
}
